import React, { useEffect, useState } from "react";
import { koreanLocationToEnglish } from "../../../../../data/locationFuntion";
import { getFetch } from "../../../../../fetch/fetch";
import { DataGridPremium, GridToolbar } from "@mui/x-data-grid-premium";

const howManyDays = 60;

const RegularmealTable2: React.FC<any> = (props: any) => {

    const [rows1, setRows1] = useState<any>([]);
    const [columns1, setColumns1] = useState<any>([
        {
            field: "date", headerName: "날짜", width: 150,
        },
        {
            field: "whenType", headerName: "종류", width: 150,
        },
        {
            field: "number", headerName: "인원수", width: 150,
        }
    ]);
    const [rows2, setRows2] = useState<any>([]);
    const [columns2, setColumns2] = useState<any>([
        {
            field : "location", headerName : "지점", width : 150,
        },
        {
            field : "name", headerName : "이름", width : 150,
        }
    ]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        start();

    }, []);

    const start = async () => {

        const newDateArray: any = [];
        const startDate = new Date();
        startDate.setDate(startDate.getDate() + 6);

        console.log(newDateArray);

        const data = await getTotalData();

        console.log(data);

        const newRows1: any = [];

        data.forEach((element: any) => {

            const oneRow : any = {};
            oneRow.id = element.targetDateString + "_" + element.whenType;


            const date = new Date(element.targetDate);
            const dayString = ["일", "월", "화", "수", "목", "금", "토"][date.getDay()];

            oneRow.date = element.targetDate + " (" + dayString + ")";

            oneRow.whenType = element.whenType === "lunch" ? "점심" : "저녁";
            oneRow.targetDateString = element.targetDateString;


            var isAlready = false;

            newRows1.forEach((row: any) => {
                if (row.id === oneRow.id) {
                    isAlready = true;
                    row.number += 1;
                }
            });

            if(isAlready){
                return;
            }

            if(!isAlready){
                oneRow.number = 1;
                newRows1.push(oneRow);
            }

        });

        newRows1.sort((a: any, b: any) => {
            if (a.targetDateString < b.targetDateString) {
                return -1;
            }
            if (a.targetDateString > b.targetDateString) {
                return 1;
            }
            return 0;
        });

        setRows1([...newRows1]);

    }

    const dateNumberToString = (dateNumber: number, whenType: string) => {

        //20210701 -> 7/1 (월요일)

        const year = Math.floor(dateNumber / 10000);
        const month = Math.floor((dateNumber % 10000) / 100);
        const date = dateNumber % 100;

        const day = new Date(year, month - 1, date).getDay();
        const dayString = ["일", "월", "화", "수", "목", "금", "토"][day];

        return `${month}/${date} (${dayString}) - ${whenType === "lunch" ? "점심" : "저녁"}`;
    }

    const getTotalData = async () => {

        try {

            setLoading(true);

            const result: any = await getFetch(`/dashboard/restaurant/regularmeal/total?howManyDays=${howManyDays}`);

            if (result.message === "success") {

                const data = result.data;

                data.forEach((element: any) => {
                    const targetDate = new Date(element.targetDate);
                    const targetDateString = targetDate.getFullYear() * 10000 + (targetDate.getMonth() + 1) * 100 + targetDate.getDate();

                    element.targetDateString = targetDateString;
                })

                return data;

            }

            setLoading(false);

        } catch (e) {
            console.warn(e);
            setLoading(false);
        }

    }




    return (
        <div>
            <div style={{
                display : "flex",
                marginTop : "32px"
            }}>
                <div style={{
                    width : "500px",
                    height : "800px"
                }}>
                    <DataGridPremium
                        rows={rows1}
                        columns={columns1}
                        density="compact"
                        components={{ Toolbar: GridToolbar }}
                    />
                </div>
            </div>
        </div>
    )


}

export default RegularmealTable2;